module.exports = __webpack_public_path__ + "img/pro_capture5.c566db0c.png";